import { Box, styled, Typography } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../../../../../utils/colors';

export const RunTitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  width: '100%',
});

interface DensityProps {
  density?: 'panel' | 'page';
}

// Same sizing as DetectionListItem's command lines -- "Démarré ·"/"Terminé ·"
// are the run-card equivalent of that small grey metadata text.
export const RunBodyText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'density',
})<DensityProps>(({ density }) => ({
  fontSize: density === 'page' ? 12 : 9,
  color: spaceCadet[400],
}));

const ResumeText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'density',
})<DensityProps>(({ density }) => ({
  flexShrink: 0,
  fontWeight: 700,
  fontSize: density === 'page' ? 13 : 12,
  color: ultraMarine[500],
  whiteSpace: 'nowrap',
}));

export default ResumeText;
